export const LEADERBOARD_COLORS = ['#6A6E75', '#BAA892', '#8A8D61', '#91877D', '#4C6374'];
